import { getNoBidClientStyle } from 'utils/helpers'
import s from './CompaniesCellRenderer.scss'
import { Link } from 'react-router-dom'

const CompaniesCellRenderer = ({ data }) => {
  if (!data) return null
  const { client_id, client_name, client_isNoBid } = data

  return (
    <Link
      className={s.link}
      style={getNoBidClientStyle(client_isNoBid)}
      to={`/companies/${client_id}`}
    >
      {client_name}
    </Link>
  )
}

export default CompaniesCellRenderer
